import { ParagraphTheme } from '@/components/Paragraph/theme';
import { GenericSlot } from 'base/components/GenericSlot';

export const Paragraph = GenericSlot({ as: 'p', theme: ParagraphTheme });
